/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useMutation } from "@apollo/react-hooks";
import Swal from 'sweetalert2'
import _ from 'lodash';
import { Spin } from 'antd';
import ApolloClient from "../../../../api/client";
import Ql from '../../../../api/ql';
import ReminderCheck from '../../../../images/icons/whitereminderscheck.svg';
import { CREATE_REMINDERS } from '../../utils/graphql';

export default function ReminderSuccess({ exitFunc, reminders }) {
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [createRemindersMutation] = useMutation(CREATE_REMINDERS, { client: ApolloClient });

  async function createReminders(userId, reminders) {
    const validReminders = reminders.map(r => ({
      ..._.omit(r, "errors"),
      genre: 'WALLET_REMINDER'
    }));

    try {
      await createRemindersMutation({
        variables: {
          input: {
            userId,
            reminders: validReminders
          },
        },
      });

      setLoading(false);
    } catch {
      await Swal.fire({
        title: "Oops... Ocorreu um erro",
        confirmButtonText: "Recomeçar",
        confirmButtonColor: "#885c85",
      })

      window.location.reload();
    }
  }

  useEffect(() => {
    if (userId && reminders) {
      createReminders(userId, reminders);
    }
  }, [userId]);

  useEffect(() => {
    (async () => {
      if (!userId) {
        const result = await new Ql('userData').get().then(response => response.data.userGet.uuid);

        setUserId(result);
      }
    })()
  }, []);

  if (loading) {
    return(
      <div className="reminder-loading">
        <Spin/>
      </div>
    );
  }

  return(
    <>
      <img src={ReminderCheck}/>
      <span>Lembrete activado com sucesso</span>
      <p>Avisamos-te 30 dias antes para decidires com tempo e calma.</p>
      <p>Se fizer sentido, mostramos-te alternativas mais vantajosas.</p>
      <p>Nada muda no teu seguro até decidires.</p>
      <button onClick={exitFunc} className="reminder-button-active">Continuar</button>
    </>
  );
}
